import React, { useEffect, useState } from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';
import { motion } from "framer-motion";
import './style.scss';

export function FullSizeBannerItem(props) {
  const item = props.item;
  const activeIndex = props.activeIndex;
  const itemIndex = props.itemIndex;
  const cmsOption = props.cmsOption || {};
  const isMobile = utils.site.isMobile();

  const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl'));

  const captionTitle = cmsUtils.payload(item, 'CaptionTitle');
  const linkUrl = cmsUtils.payload(item, 'LinkUrl');
  const bgUrlMobile = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl2'));
  const lockup = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl3'));
  const lockupAlign = cmsUtils.payload(item, 'LockupAlign') || '50%';
  const lockupAlignM = cmsUtils.payload(item, 'LockupAlignM') || '50%';

  const cssClass = utils.classNames('cms_item', 'banner-item2', item.cssClass || item.anchorName || '');

  const [shouldAnimate, setShouldAnimate] = useState(false);
  useEffect(() => {
    if (itemIndex === activeIndex) {
      setShouldAnimate(true);
    } else {
      setShouldAnimate(false);
    }
  }, [activeIndex, itemIndex]);

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}
      style={{ backgroundImage: utils.css.bgUrlStyle(isMobile ? bgUrlMobile : bgUrl) }}
    >
      <div className='lock-up-container' style={{ top: isMobile ? lockupAlignM : lockupAlign }}>
        {lockup && (
          <motion.img
            // key={`${item.itemId}-${activeIndex}`}
            src={lockup}
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -100, opacity: 0 }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />
        )}
      </div>
      <div className='full-screen-button-container'>
        <SiteLink to={linkUrl} className="full-screen-button"><span>{captionTitle}</span></SiteLink>
      </div>
    </div>
  );
}
